import BaseAuthenticationModel from "scripts/models/baseAuthenticationModel";

class SessionSubjectModel extends BaseAuthenticationModel {
  url() {
    return `${this.authenticationUrlRoot}/authentication/subject`;
  }
}

export default SessionSubjectModel;
